import { FloatingBanner } from '@ui/components/FloatingBanner';

// Связь с комнатой прервалась: плашка всегда на виду, где бы ни был скролл
export function ReconnectingBanner() {
  return <FloatingBanner>Связь прервалась, восстанавливаем...</FloatingBanner>;
}
